import React from "react";
import { Link } from "react-router-dom";
import Seo from "../components/Seo";

export default function NotFound() {
  return (
    <div className="container-x py-24 text-center" data-testid="not-found-page">
      <Seo title="Page not found" description="The page you are looking for does not exist." noindex />
      <div className="text-sm uppercase tracking-widest text-black/50">Error 404</div>
      <h1 className="font-serif text-4xl md:text-5xl mt-4">Page Not Found</h1>
      <p className="text-black/60 mt-4 max-w-md mx-auto">
        The page you're looking for doesn't exist or may have been moved.
      </p>
      <Link to="/" className="btn-filled inline-block mt-8" data-testid="not-found-home">Back to homepage</Link>
    </div>
  );
}
